import * as React from "react";
const SvgDone = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8.68,19.28A1.09,1.09,0,0,1,8,19L2.32,13.58a1,1,0,0,1,1.44-1.51l4.9,4.7L20.22,5A1,1,0,0,1,21.7,6.49L9.43,19A1.05,1.05,0,0,1,8.68,19.28Z" }));
export default SvgDone;
